




import { Component, Vue } from "vue-property-decorator";

import AutomaticReportsList from "@/components/Settings/AutomaticReportsList.vue";

// Thin route view: the list is a component so it can also be mounted outside the
// Settings shell.
@Component({ components: { AutomaticReportsList } })
export default class AutomaticReports extends Vue {}
